/* eslint-disable no-use-before-define,react-hooks/exhaustive-deps */
import React from 'react'
import { fmt, subscribe, unsubscribe } from '../../twd'
import { useOrderTicket } from '../use-order-ticket.js'

export const SalesCredit = () => {
    const { orderInfo, hasMarket, isRfq, calculateTicket, isTreasuryAuction } = useOrderTicket()

    const [calculating, setCalculating] = React.useState(false)
    const [calc, setCalc] = React.useState({
        comm: 0,
        netMoney: 0
    })

    React.useEffect(() => {
        if (calculating) {
            setCalc({comm: 0, netMoney:0})
            return
        }
        setCalc({
            comm: orderInfo.sugg_comm_in_dlrs_per_tckt || 0,
            netMoney: orderInfo.netMoney || 0,
        })
    }, [calculating, orderInfo])


    const calcTotals = async ({isSkipErrors}) => {
        setCalculating(true)
        const a = await calculateTicket({isSkipErrors})
        if (a) {
            orderInfo.sugg_comm_in_dlrs_per_tckt = a.sugg_comm_in_dlrs_per_tckt
            orderInfo.netMoney = a.netMoney
        }
        setCalculating(false)
    }

    React.useEffect(() => {
        let subId = subscribe('order_ticket_recalc_totals.order_ticket_form_sales_credit', () => {
            calcTotals({isSkipErrors:true})
        })

        return () => {
            unsubscribe(subId)
        }
    }, [])

    if (!isTreasuryAuction && (isRfq || !hasMarket)) return null

    return <React.Fragment>
    <div style={{minWidth:'90px', display:'inline-block'}}>
        <div>Comm.</div>
        <div className='text-bold' >{fmt.money(calc.comm)}</div>
    </div>
    <div style={{minWidth:'90px', display:'inline-block'}}>
        <div >Est. Total</div>
        <div className='text-bold'>{isTreasuryAuction ? 'Auction' : fmt.money(calc.netMoney)}</div>
    </div>

    {!isTreasuryAuction &&
        <div style={{minWidth:'90px', display:'inline-flex', verticalAlign:'middle'}}>
            {!calculating && <button
                className="link-button"
                onClick={calcTotals}
            >Calculate totals</button>}
            {calculating && <Calculating />}

        </div>}
    </React.Fragment>
}

 const Calculating = () => {
    return <div data-name="calculating-spinner" className="spinner" style={{width:'30px'}} aria-busy="true">
        <svg className="circular" viewBox="25 25 50 50">
        <circle className="background" cx="50" cy="50" fill="none" r="20" strokeMiterlimit="10" strokeWidth="2"></circle>
        <circle className="path" cx="50" cy="50" fill="none" r="20" strokeMiterlimit="10" strokeWidth="2"></circle>
        </svg>
        </div>
}
